import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: schools.Address and finance.Address (same fields).
export default class Address extends Fragment {
  declare [Type]: 'address';

  @attr('string', { defaultValue: '' })
  declare number: string;

  @attr('string', { defaultValue: '' })
  declare street: string;

  @attr('string', { defaultValue: '' })
  declare locality: string;

  @attr('string', { defaultValue: '' })
  declare district: string;

  @attr('string', { defaultValue: '' })
  declare region: string;

  @attr('string', { defaultValue: '' })
  declare postcode: string;
}
